export default function BotonDivLeft2({ tituloBoton, onClick, style }) {
  return (
    <div onClick={onClick} className="botonCardLeft2" style={style}>
      {tituloBoton}
    </div>
  );
}
